(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncp-blog-article"]) return;
  try {
    
function initializeNcpGuide() {
  const body = document.querySelector('.ncp-guide-body');
  const progress = document.querySelector('.ncp-guide-progress');
  if (!body || !progress || body.dataset.guideReady) return;
  body.dataset.guideReady = 'true';
  let queued = false;
  const update = () => {
    const top = body.getBoundingClientRect().top + window.scrollY;
    const distance = Math.max(1, body.offsetHeight - window.innerHeight);
    const value = Math.max(0, Math.min(100, (window.scrollY - top) / distance * 100));
    progress.querySelector('span').style.width = value + '%';
    progress.setAttribute('aria-valuenow', Math.round(value));
    queued = false;
  };
  window.addEventListener('scroll', () => {
    if (!queued) { queued = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', update);
  update();
  const links = document.querySelectorAll('.ncp-guide-aside a');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        links.forEach(link => {
          if (link.getAttribute('href') === '#' + entry.target.id) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      });
    }, { rootMargin: '-110px 0px -65% 0px', threshold: 0 });
    body.querySelectorAll('h2[id]').forEach(heading => observer.observe(heading));
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeNcpGuide);
else initializeNcpGuide();
document.addEventListener('shopify:section:load', initializeNcpGuide);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncp-corporate-page"]) return;
  try {
    
(function(){
function expandService(hash){
if(!hash)return;
var target=document.getElementById(hash.slice(1));
if(!target)return;
var section=target.matches(".ncp-services-accordion")?target:target.closest(".ncp-services-accordion");
if(section)section.open=true;
}
document.addEventListener("click",function(event){
var link=event.target.closest('a[href*="#"]');
if(link){var destination=new URL(link.href,window.location.href);if(destination.pathname===window.location.pathname)expandService(destination.hash);}
});
window.addEventListener("hashchange",function(){expandService(window.location.hash);});
expandService(window.location.hash);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncp-header"]) return;
  try {
    
document.addEventListener("keydown", function(event) { if (event.key === "Escape") { document.querySelectorAll(".ncp-site-header details[open]").forEach(function(item) { item.open = false; }); var nav = document.getElementById("ncp-mobile-nav"); if (nav) nav.classList.remove("is-open"); var button = document.querySelector(".ncp-menu-btn"); if (button) button.setAttribute("aria-expanded", "false"); } });
document.addEventListener("click", function(event) { document.querySelectorAll(".ncp-nav-dropdown[open]").forEach(function(item) { if (!item.contains(event.target)) item.open = false; }); });
document.querySelectorAll(".ncp-header-search").forEach(function(search) { search.addEventListener("toggle", function() { if (search.open) search.querySelector("input[type=search]").focus(); }); });
document.addEventListener("click", function(event) { document.querySelectorAll(".ncp-header-search[open]").forEach(function(search) { if (!search.contains(event.target)) search.open = false; }); });

  } catch(e) { console.error(e); }
})();
})();
